import CameraSection from "../ailights-components/CameraSection";
import SoccerSection from "../ailights-components/SoccerSection";
import TennisSection from "../ailights-components/TennisSection";
import PadelSection from "../ailights-components/PadelSection";
import InfoSection from "../ailights-components/InfoSection";

function Ailights() {
    return (
        <main className="overflow-x-hidden">
            <CameraSection />
            <SoccerSection />
            <TennisSection />
            <PadelSection />
            <InfoSection />
        </main>
    );
}

export default Ailights;
